import { createRoot, hydrateRoot } from "react-dom/client";
import App from "./app/App.tsx";
import "./styles/index.css";

const root = document.getElementById("root")!;

// scripts/prerender.mjs build sırasında #root'u statik HTML ile doldurur.
// Doluysa üzerine hydrate ediyoruz — böylece ilk boyama JS beklemiyor.
// Boşsa (dev sunucusu) normal client render.
if (root.firstElementChild) {
  hydrateRoot(root, <App />);
} else {
  createRoot(root).render(<App />);
}
